// Package imports:
import React from 'react';
// Component imports:
import DisplayBox from '../../../ui-elements/DisplayBox/DisplayBox';
import Table from '../../../ui-elements/Table/Table';
import Radio from '../../../ui-elements/Radio/Radio';
import Input from '../../../ui-elements/Input/Input';
import Checkbox from '../../../ui-elements/Input/Checkbox';
import Button from '../../../ui-elements/Button/Button';
import { insertDash } from '../../../services/utils';

const CompanyKYCExample: React.FC = () => {
    return (
        <div className="kyc-example">
            <h1>Áreiðanleikakönnun</h1>
            <div className="KCL_company-title">
                <div className="info-col">
                    <div className="info-item">
                        <span className="title">Fyrirtæki</span>
                        <span className="value companyName">Dæmi ehf.</span>
                    </div>
                </div>
                <div className="info-col">
                    <div className="info-item">
                        <span className="title">Kennitala</span>
                        <span className="value">451267-3489</span>
                    </div>
                </div>
                <div className="info-col">
                    <div className="info-item">
                        <span className="title">Póstfang</span>
                        <span className="value">Borgartúni 25, 105 Reykjavík</span>
                    </div>
                </div>
            </div>
            <DisplayBox displayBoxSize="xl" grayBackground>
                <ol className="kyc-questions">
                    <li>
                        <p className="paragraph--bold">
                            Er skattaleg heimilisfesti félagsins á Íslandi?
                        </p>
                        <div className="radios-group">
                            <ul>
                                <li>
                                    <Radio id="yes" name="yes" value="yes" defaultValue="" onChange={() => { }}>Já</Radio>
                                </li>
                                <li>
                                    <Radio id="no" name="no" value="no" defaultValue="" onChange={() => { }}>Nei</Radio>
                                </li>
                            </ul>
                        </div>
                    </li>
                    <li>
                        <p className="paragraph--bold">
                            Stundar félagið viðskipti með mikið reiðufé?
                        </p>
                        <div className="radios-group">
                            <ul>
                                <li>
                                    <Radio id="yes" name="yes" value="yes" defaultValue="" onChange={() => { }}>Já</Radio>
                                </li>
                                <li>
                                    <Radio id="no" name="no" value="no" defaultValue="" onChange={() => { }}>Nei</Radio>
                                </li>
                            </ul>
                        </div>
                    </li>
                    <li>
                        <p className="paragraph--bold">
                            Uppruni fjármuna
                        </p>
                        <p className="paragraph-small">
                            Tilgreindu uppruna þeirra fjármuna sem notaði eru til viðskipta við Þjónustuaðila.
                        </p>
                        <div className="radios-group">
                            <ul>
                                <li>
                                    <Radio id="opt1" name="opt1" value="opt1" defaultValue="" onChange={() => { }}>Fjármagnstekjur, laun</Radio>
                                </li>
                                <li>
                                    <Radio id="opt2" name="opt2" value="opt2" defaultValue="" onChange={() => { }}>Rekstrartekjur</Radio>
                                </li>
                                <li>
                                    <Radio id="opt3" name="opt3" value="opt3" defaultValue="" onChange={() => { }}>Annað</Radio>
                                </li>
                            </ul>
                        </div>
                    </li>
                    <li>
                        <p className="paragraph--bold">
                            Eru viðskipti stunduð við ósamvinnuþýð ríki?
                        </p>
                        <p className="paragraph-small">
                            Ósamvinnuþýð ríki falla undir skilgreiningu FATF samanber reglugerð 956/2020.
                        </p>
                        <div className="radios-group">
                            <ul>
                                <li>
                                    <Radio id="yes" name="yes" value="yes" defaultValue="" onChange={() => { }}>Já</Radio>
                                </li>
                                <li>
                                    <Radio id="no" name="no" value="no" defaultValue="" onChange={() => { }}>Nei</Radio>
                                </li>
                            </ul>
                        </div>
                    </li>
                    <li>
                        <p className="paragraph--bold">
                            Tilgangur viðskipta
                        </p>
                        <p className="paragraph-small">
                            Hver er tilgangur fyrirhugaðra viðskipta, þ.e. þjónustu sem þú munt nýta þér hjá Þjónustuaðila?
                        </p>
                        <Input
                            label="Tilgangur viðskipta"
                            inputSize="lg"
                            disabled
                        />
                    </li>
                    <li>
                        <p className="paragraph--bold">
                            Eru viðskiptin í þágu þriðja aðila?
                        </p>
                        <p className="paragraph-small">
                            Er sú þjónusta sem þú sækist eftir vegna þriðja aðila, en ekki þín eða félags sem þú ert í forsvari fyrir?
                        </p>
                        <div className="radios-group">
                            <ul>
                                <li>
                                    <Radio id="yes" name="yes" value="yes" defaultValue="" onChange={() => { }}>Já</Radio>
                                </li>
                                <li>
                                    <Radio id="no" name="no" value="no" defaultValue="" onChange={() => { }}>Nei</Radio>
                                </li>
                            </ul>
                        </div>
                    </li>
                    <li>
                        <p className="paragraph--bold">
                            Ert þú í áhættuhópi vegna stjórnmálalegra tengsla?
                        </p>
                        <p className="paragraph-small">
                            Til einstaklinga í áhættuhópi vegna stjórnmálalegra tengsla teljast þeir einstaklingar, innlendir og erlendir, sem eru eða hafa verið háttsettir í opinberri þjónustu, ásamt nánustu fjölskyldu þeirra og samstarfsmönnum.
                        </p>
                        <div className="radios-group">
                            <ul>
                                <li>
                                    <Radio id="yes" name="yes" value="yes" defaultValue="" onChange={() => { }}>Já</Radio>
                                </li>
                                <li>
                                    <Radio id="no" name="no" value="no" defaultValue="" onChange={() => { }}>Nei</Radio>
                                </li>
                            </ul>
                        </div>
                    </li>
                    <li>
                        <p className="paragraph--bold">
                            Aðrir stjórnendur félagsins
                        </p>
                        <p className="paragraph-small">
                            Hefur einhver af stjórnendum félagsins eða aðrir sem hafa heimild til að skuldbinda félagið, þeirra nánasta fjölskylda eða nánir samstarfsmenn verið háttsettir í opinberri þjónustu síðastliðna tólf mánuði?
                        </p>
                        <div className="radios-group">
                            <ul>
                                <li>
                                    <Radio id="yes" name="yes" value="yes" defaultValue="" onChange={() => { }}>Já</Radio>
                                </li>
                                <li>
                                    <Radio id="no" name="no" value="no" defaultValue="" onChange={() => { }}>Nei</Radio>
                                </li>
                            </ul>
                        </div>
                    </li>
                    <li>
                        <p className="paragraph--bold">
                            Raunverulegir eigendur
                        </p>
                        <p className="paragraph-small">
                            Raunverulegur eigandi telst sá einstaklingur sem á eða ræður yfir &gt;25% hlut í félaginu, beint eða óbeint.
                        </p>
                        <div className="company-info-section">
                            <Table
                                tableSize="lg"
                                data={[{
                                    name: "Kelda Kóðadóttir",
                                    birthMonth: "1979/10",
                                    ownedPercent: "54.30%"
                                }]}
                                columns={[{
                                    title: "Nafn",
                                    renderCell: ({ name }) => name,
                                    textAlign: "left"
                                }, {
                                    title: "Fæðingarár/mán.",
                                    renderCell: ({ birthMonth }) => birthMonth,
                                    textAlign: "left"
                                }, {
                                    title: "Eignarhlutur",
                                    renderCell: ({ ownedPercent }) => ownedPercent,
                                    textAlign: "right"
                                }]}
                            />
                        </div>
                        <p className="paragraph-small--bold">
                            Staðfesta raunverulega eigendur?
                        </p>
                        <div className="radios-group">
                            <ul>
                                <li>
                                    <Radio id="yes" name="yes" value="yes" defaultValue="" onChange={() => { }}>Já</Radio>
                                </li>
                                <li>
                                    <Radio id="no" name="no" value="no" defaultValue="" onChange={() => { }}>Nei</Radio>
                                </li>
                            </ul>
                        </div>
                    </li>
                    <li>
                        <p className="paragraph--bold">
                            Upplýsingar úr fyrirtækjaskrá
                        </p>
                        <div className="company-info-section">
                            <div className="company-info-subsection">
                                <h5>Stjórn félags</h5>
                                <Table
                                    tableSize="lg"
                                    data={[{
                                        ssn: "190189-2349",
                                        name: "Jón Kelddal",
                                        address: "Kelduvogur 20",
                                        role: "Meðstjórnandi"
                                    }, {
                                        ssn: "010101-0100",
                                        name: "Sýnir Dæmason",
                                        address: "Hvergigata 4",
                                        role: "Meðstjórnandi"
                                    }, {
                                        ssn: "170691-1239",
                                        name: "Dæmi Sýnis",
                                        address: "Hvergigata 5",
                                        role: "Stjórnarformaður"
                                    }]}
                                    columns={[{
                                        title: "Kennitala",
                                        renderCell: ({ ssn }) => insertDash(ssn),
                                        textAlign: "left"
                                    }, {
                                        title: "Nafn",
                                        renderCell: ({ name }) => name,
                                        textAlign: "left"
                                    }, {
                                        title: "Heimilisfang",
                                        renderCell: ({ address }) => address,
                                        textAlign: "left"
                                    }, {
                                        title: "Staða",
                                        renderCell: ({ role }) => role,
                                        textAlign: "left"
                                    }]}
                                />
                            </div>
                            <div className="company-info-subsection">
                                <h5>Endurskoðendur</h5>
                                <Table
                                    tableSize="lg"
                                    data={[{
                                        ssn: "210987-6549",
                                        name: "Dæmhildur Sýnmundsdóttir",
                                        address: "Keldugata 1"
                                    }, {
                                        ssn: "560178-2349",
                                        name: "Endurskoðendadæmi ehf.",
                                        address: "Endurskoðendavegur 4"
                                    }]}
                                    columns={[{
                                        title: "Kennitala",
                                        renderCell: ({ ssn }) => insertDash(ssn),
                                        textAlign: "left"
                                    }, {
                                        title: "Nafn",
                                        renderCell: ({ name }) => name,
                                        textAlign: "left"
                                    }, {
                                        title: "Heimilisfang",
                                        renderCell: ({ address }) => address,
                                        textAlign: "left"
                                    }]}
                                />
                            </div>
                            <div className="company-info-subsection">
                                <h5>Framkvæmdastjórn</h5>
                                <Table
                                    tableSize="lg"
                                    data={[{
                                        ssn: "091079-1239",
                                        name: "Kelda Kóðadóttir",
                                        address: "Kelduvogur 20"
                                    }]}
                                    columns={[{
                                        title: "Kennitala",
                                        renderCell: ({ ssn }) => insertDash(ssn),
                                        textAlign: "left"
                                    }, {
                                        title: "Nafn",
                                        renderCell: ({ name }) => name,
                                        textAlign: "left"
                                    }, {
                                        title: "Heimilisfang",
                                        renderCell: ({ address }) => address,
                                        textAlign: "left"
                                    }]}
                                />
                            </div>
                            <div className="company-info-subsection">
                                <h5>Prókúruumboð</h5>
                                <Table
                                    tableSize="lg"
                                    data={[{
                                        ssn: "091079-1239",
                                        name: "Kelda Kóðadóttir",
                                        address: "Kelduvogur 20"
                                    }]}
                                    columns={[{
                                        title: "Kennitala",
                                        renderCell: ({ ssn }) => insertDash(ssn),
                                        textAlign: "left"
                                    }, {
                                        title: "Nafn",
                                        renderCell: ({ name }) => name,
                                        textAlign: "left"
                                    }, {
                                        title: "Heimilisfang",
                                        renderCell: ({ address }) => address,
                                        textAlign: "left"
                                    }]}
                                />
                            </div>
                            <div className="company-info-subsection">
                                <h5>Stofnendur</h5>
                                <Table
                                    tableSize="lg"
                                    data={[{
                                        ssn: "091079-1239",
                                        name: "Kelda Kóðadóttir",
                                        address: "Kelduvogur 20"
                                    }]}
                                    columns={[{
                                        title: "Kennitala",
                                        renderCell: ({ ssn }) => insertDash(ssn),
                                        textAlign: "left"
                                    }, {
                                        title: "Nafn",
                                        renderCell: ({ name }) => name,
                                        textAlign: "left"
                                    }, {
                                        title: "Heimilisfang",
                                        renderCell: ({ address }) => address,
                                        textAlign: "left"
                                    }]}
                                />
                            </div>
                            <div className="company-info-subsection">
                                <h6>Tilgangur</h6>
                                <p className="paragraph-small">
                                    Tilgangur félagsins er hugbúnaðargerð, almenn upplýsingamiðlun, tölvuvinnsla, ráðgjöf og skyld starfsemi ásamt almennum fjárfestingum.
                                </p>
                            </div>
                            <div className="company-info-subsection">
                                <h6>ÍSAT flokkun</h6>
                                <p className="paragraph-small">
                                    62.01.0 - Hugbúnaðargerð
                                </p>
                            </div>
                        </div>
                        <p className="paragraph-small--bold">
                            Staðfesta upplýsingar úr fyrirtækjaskrá?
                        </p>
                        <div className="radios-group">
                            <ul>
                                <li>
                                    <Radio id="yes" name="yes" value="yes" defaultValue="" onChange={() => { }}>Já</Radio>
                                </li>
                                <li>
                                    <Radio id="no" name="no" value="no" defaultValue="" onChange={() => { }}>Nei</Radio>
                                </li>
                            </ul>
                        </div>
                    </li>
                </ol>
                <div className="confirm-info">
                    <p className="paragraph--bold">
                        Staðfesting á réttum upplýsingum
                    </p>
                    <p className="paragraph-small">
                        Ég staðfesti að þær upplýsingar sem ég hef veitt hér að ofan séu réttar eftir minni bestu vitund og skuldbind mig til að tilkynna Þjónustuaðila skriflega um breytingar á þeim eins fljótt og mögulegt er.
                    </p>
                    <Checkbox
                        label="Ég samþykki"
                        disabled
                    />
                </div>
                <div className="actions">
                    <Button
                        buttonType="secondary"
                        size="lg"
                    >
                        Hætta við
                    </Button>
                    <Button
                        buttonType="primary"
                        size="lg"
                    >
                        Staðfesta
                    </Button>
                </div>
            </DisplayBox>
        </div>
    );
}

export default CompanyKYCExample;